import { render, staticRenderFns } from "./Patholog.vue?vue&type=template&id=5a70066a&"
import script from "./Patholog.vue?vue&type=script&lang=js&"
export * from "./Patholog.vue?vue&type=script&lang=js&"
import style0 from "./Patholog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports